<span class="-value" [innerHTML]="displayValue?.value"></span>@if (displayValue?.currencySymbol) {@if (displayValue.currencySymbol === '%') {%} @else { <span class="-currency">{{displayValue.currencySymbol}}</span>}}
